import { Box } from '@dtx-company/shared-components/src/components/atoms/Box/index'
import { TableRow } from '@dtx-company/shared-components/src'
import styled from 'styled-components'

export const InfoContainer = styled(Box)`
  flex-direction: column;
  > :not(:last-child) {
    margin-bottom: 16px;
  }
`
export const DescriptionList = styled.ul`
  padding-left: 20px;
  > :not(:last-child) {
    margin-bottom: 7px;
  }
`
export const StyledTableRow = styled(TableRow)`
  user-select: none;
  box-shadow: none;
`
export const DropdownMenuItems = styled(Box)`
  ::-webkit-scrollbar {
    width: 4px;
    &:horizontal {
      height: 0;
    }
  }

  ::-webkit-scrollbar-track {
    box-shadow: none;
  }

  ::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.secondary.border};
    border-radius: 4px;
  }
`
